import React from 'react';
import Container from '../layouts/Containerlayout';
import Nav from '../sections/Nav'
import Hero from '../sections/Hero'
import About from '../sections/About'
import Experience from '../sections/Experience'
import SkillsSection from '../sections/SkillsSection';
import Projects from '../sections/Projects'
import Services from '../sections/Services'
import Contact from '../sections/Contact'
function Landingpage(props) {
    return (
        <>
        <Nav />
        <Hero />
        <Container>
            <About />
            <Experience />
            <Services />
            <SkillsSection />
            <Projects />
            <Contact />
        </Container>
        </>
    );
}

export default Landingpage;